module.exports = __webpack_public_path__ + "static/media/pipe-fabrication.51364921.jpg";